import React from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import BentoGrid from "@/components/BentoGrid";
import AmbassadorsSection from "@/components/AmbassadorsSection";
import CtaSection from "@/components/CtaSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen relative" style={{ backgroundImage: `url('https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/mqf2m4hk_fondo%201.jpg')`, backgroundPosition: 'calc(50% - 130px) -70px', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundColor: '#E8E4DE' }}>
      {/* Scrollable content */}
      <div className="relative z-10">
        <Header />
        <main>
          <HeroSection />
          <BentoGrid />
          <AmbassadorsSection />
          <CtaSection />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </div>
  );
}
